export default __webpack_public_path__ + "static/champion-htf-heavyweight-webfont-823e7ab60877466e7a1ddc56262b5922.ttf";